"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _ClearIcon;
function FieldValue(_ref) {
  var computedValue = _ref.computedValue,
    dense = _ref.dense,
    id = _ref.id,
    truncate = _ref.truncate,
    type = _ref.type;
  if (typeof computedValue === 'undefined' || computedValue === null) {
    return /*#__PURE__*/_react.default.createElement(_material.Typography, {
      id: id,
      variant: "body2"
    }, "\u2014");
  }
  if (type === 'boolean') {
    return computedValue === true ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.Done, {
      id: id
    }) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.Remove, {
      color: "disabled",
      id: id
    });
  }
  if (type === 'datetime' || type === 'multilineDatetime') {
    return /*#__PURE__*/_react.default.createElement(_material.Typography, {
      id: id,
      variant: "body2"
    }, new Date(computedValue).toLocaleString());
  }
  if (type === 'numberInput') {
    return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({
      fullWidth: true,
      id: id,
      type: "number"
    }, computedValue));
  }
  if (type === 'textInput') {
    return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({
      fullWidth: true,
      id: id
    }, computedValue));
  }
  if (type === 'checkbox') {
    return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
      control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, (0, _extends2.default)({
        style: {
          color: computedValue.color
        },
        value: "gilad"
      }, (0, _extends2.default)({}, computedValue, {
        color: undefined,
        label: undefined
      }))),
      id: id,
      label: computedValue.label
    });
  }
  if (type === 'clear') {
    return /*#__PURE__*/_react.default.createElement(_material.IconButton, (0, _extends2.default)({
      "aria-label": "Clear",
      size: dense ? 'small' : 'medium'
    }, computedValue, {
      id: "".concat(id, "ClearButton")
    }), _ClearIcon || (_ClearIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Clear, null)));
  }
  if (type === 'action' || type === 'expandable' || type === 'custom') {
    return computedValue;
  }
  var truncateValue = function truncateValue(value) {
    return value.length > truncate ? "".concat(value.substring(0, truncate), "...") : value;
  };
  return /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: id,
    variant: "body2"
  }, truncate ? truncateValue(computedValue) : computedValue);
}
function mapStateToProps(state, _ref2) {
  var mapStateToValue = _ref2.mapStateToValue,
    value = _ref2.value;
  return {
    computedValue: typeof mapStateToValue === 'function' ? mapStateToValue(state, value) : value
  };
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(FieldValue);